import hasPermission from './hasPermission'

// The teams whose org grants `permission`; a team without an org id is judged by the selected org.
// Asked once per org rather than per team: hasPermission parses localStorage, and a federation's
// hundreds of teams are filtered on every calendar render.
const filterTeamsByPermission = (teams, permission) => {
  const allowedByOrg = new Map()
  return teams?.filter((team) => {
    const orgId = team.org?.id || team.orgId
    if (!allowedByOrg.has(orgId)) allowedByOrg.set(orgId, hasPermission(permission, orgId ? [orgId] : undefined))
    return allowedByOrg.get(orgId)
  })
}

export default filterTeamsByPermission
